import script from "./QuizGenerate.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizGenerate.vue?vue&type=script&setup=true&lang=js"

import "./QuizGenerate.vue?vue&type=style&index=0&id=11e4cae4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11e4cae4"]])

export default __exports__